import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

export interface DialogSolicitarObjetivoForzadoData {
    personId: number;
    periodId: number;
}

@Component({
    selector: "dialog-solicitar-objetivo-forzado",
    templateUrl: "./dialog-solicitar-objetivo-forzado.component.html",
    styleUrls: ["./dialog-solicitar-objetivo-forzado.component.scss"],
    standalone: false
})
export class DialogSolicitarObjetivoForzadoComponent implements OnInit {
    formSolicitarObjetivo: FormGroup;
    maxTitleLength = 250;
    maxDescriptionLength = 1024;
    minTitleLength = 5;
    maxWeight = 100;
    minWeight = 0;

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<DialogSolicitarObjetivoForzadoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSolicitarObjetivoForzadoData,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.formSolicitarObjetivo = this.fb.group({
            titulo: [
                "",
                [
                    Validators.required,
                    Validators.minLength(this.minTitleLength),
                    Validators.maxLength(this.maxTitleLength)
                ]
            ],
            descripcion: ["", [Validators.maxLength(this.maxDescriptionLength)]],
            fechaInicio: [""],
            fechaFin: [""],
            weight: [0, [Validators.required, Validators.min(this.minWeight), Validators.max(this.maxWeight)]]
        });
    }

    get titulo() {
        return this.formSolicitarObjetivo.get("titulo");
    }

    get descripcion() {
        return this.formSolicitarObjetivo.get("descripcion");
    }

    get fechaInicio() {
        return this.formSolicitarObjetivo.get("fechaInicio");
    }

    get fechaFin() {
        return this.formSolicitarObjetivo.get("fechaFin");
    }

    get weight() {
        return this.formSolicitarObjetivo.get("weight");
    }

    get tituloCaracteresRestantes(): number {
        const tituloValue = this.titulo?.value || "";
        return this.maxTitleLength - tituloValue.length;
    }

    get descripcionCaracteresRestantes(): number {
        const descripcionValue = this.descripcion?.value || "";
        return this.maxDescriptionLength - descripcionValue.length;
    }

    get puedeConfirmar(): boolean {
        return this.formSolicitarObjetivo.valid && this.titulo?.value?.length >= this.minTitleLength;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        if (this.puedeConfirmar) {
            this.dialogRef.close({
                confirmado: true,
                datos: {
                    personId: this.data.personId,
                    periodId: this.data.periodId,
                    titulo: this.titulo?.value,
                    descripcion: this.descripcion?.value,
                    fechaInicio: this.fechaInicio?.value,
                    fechaFin: this.fechaFin?.value,
                    weight: this.weight?.value
                }
            });
        }
    }
}
